<template>
  <div class="card shadow" :class="type === 'dark' ? 'bg-default' : ''">
    <div
      class="card-header border-0"
      :class="type === 'dark' ? 'bg-transparent' : ''"
    >
      <div class="row align-items-center">
        <div class="col">
          <h3 class="mb-0" :class="type === 'dark' ? 'text-white' : ''">
            {{ title }}
          </h3>
        </div>
      </div>
    </div>

    <div class="table-responsive">
      <base-table
        class="table align-items-center table-flush"
        :class="type === 'dark' ? 'table-dark' : ''"
        :thead-classes="type === 'dark' ? 'thead-dark' : 'thead-light'"
        tbody-classes="list"
        :data="logs"
      >
        <template slot="columns">
          <th>วัน/เวลา</th>
          <th>ชื่อพนักงาน</th>
          <th>สิ่งที่ทำ</th>
          <th>ลูกค้า</th>
          <th></th>
        </template>

        <template slot-scope="{ row }">
          <td class="dateime">
            {{ formatDate(row.created_at) }}
          </td>
          <td class="employee_name">
            {{ row.user !== null ? row.user.name : "" }}
          </td>
          <td class="action">
            {{
              row.log_name !== "default"
                ? row.description + " " + row.log_name
                : row.description
            }}
          </td>
          <td class="menu">
            {{ JSON.parse(row.properties).attributes.name }}
          </td>
          <td class="detail">
            <!-- {{ JSON.parse(row.properties) }} -->
            <base-button
              type="primary"
              size="sm"
              @click="
                (showModal = true), (selectedData = JSON.parse(row.properties))
              "
              >รายละเอียด</base-button
            >
          </td>
        </template>
      </base-table>
    </div>

    <div
      class="card-footer d-flex justify-content-end"
      :class="type === 'dark' ? 'bg-transparent' : ''"
    ></div>
    <Modal :show="showModal">
      <div class="col text-center">
        <h2 align="left">รายละเอียด</h2>
        <button
          type="button"
          class="close mt--5"
          data-dismiss="modal"
          aria-label="Close"
          @click="showModal = false"
        >
          <span>×</span>
        </button>
        <br v-if="selectedData.old" />
        <h4 align="left" v-if="selectedData.old">ข้อมูล</h4>
        <h5
          align="left"
          v-for="(att, index) in selectedData.attributes"
          :key="index"
        >
          {{ index }} : {{ att }}
        </h5>
        <br />
        <h4 align="left" v-if="selectedData.old">ข้อมูลก่อนแก้ไข</h4>
        <h5
          align="left"
          v-for="(oldattributes, key) in selectedData.old"
          :key="key"
        >
          {{ key }} : {{ oldattributes }}
        </h5>
        <div class="row justify-content-around mt-4">
          <base-button
            type="warning"
            size="md"
            @click="(showModal = false), (selectedData = '')"
            >ปิด</base-button
          >
        </div>
      </div></Modal
    >
  </div>
</template>
<script>
import axios from "axios";
import Modal from "../../components/Modal";
import moment from "moment";

moment.locale("th");

export default {
  name: "log-table",
  components: {
    Modal,
  },
  data() {
    return {
      showModal: false,
      selectedData: "",
      keyword: "",
    };
  },
  props: {
    type: {
      type: String,
    },
    title: String,
    logs: {
      type: Array,
      default: function() {
        return [];
      },
    },
    total: {
      type: Number,
    },
    page: {
      type: Number,
    },
  },
  computed: {
    calculateTotal() {
      return this.logs.length;
    },
  },
  methods: {
    formatDate(date) {
      let monthNames = [
        "ม.ค.",
        "ก.พ.",
        "มี.ค.",
        "เม.ย.",
        "พ.ค.",
        "มิ.ย.",
        "ก.ค.",
        "ส.ค.",
        "ก.ย.",
        "ต.ค.",
        "พ.ย.",
        "ธ.ค.",
      ];

      let day = moment(date).date();
      let month = monthNames[moment(date).month()];
      let year = moment(date).year() + 543;

      // let parsedDate = Date.parse(date);
      // let newDate = new Date(parsedDate);
      // let day = newDate.getDate();
      // let month = newDate.getMonth();
      // let year = newDate.getYear();

      // let hour = newDate.getHours();
      // let min = newDate.getMinutes();
      // let sec = newDate.getSeconds();
      // return (
      //   day +
      //   " " +
      //   monthNames[month] +
      //   " " +
      //   (year + 543 + 1900) +
      //   " " +
      //   hour +
      //   ":" +
      //   min +
      //   ":" +
      //   sec
      // );
      return day + " " + month + " " + year;
    },
    loadLogs: function() {
      var localApp = this;
      axios
        .get("/api/log?page=" + localApp.page, {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then(function(response) {
          localApp.$emit("update:logs", response.data.data.data);
          localApp.$emit("update:total", response.data.data.total);
        })
        .catch(function() {
          localApp.kick();
        });
    },
    search: async function(keyword) {
      let localApp = this;
      localApp.keyword = keyword;
      await axios
        .get(
          "/api/log/search/q?keyword=" +
            keyword +
            "&page=" +
            localApp.page,
          {
            headers: {
              Authorization: "Bearer " + localStorage.token,
            },
          }
        )
        .then(function(response) {
          localApp.$emit("update:logs", response.data.data.data);
          localApp.$emit("update:total", response.data.data.total);
        })
        .catch(function(error) {
          alert(error);
        });
    },
  },
  watch: {
    page: function() {
      if (this.keyword === "") {
        this.loadLogs();
      } else {
        this.search(this.keyword);
      }
    },
  },
  created: function() {
    if (!localStorage.token) {
      this.kick();
    } else {
      this.loadLogs();
    }
  },
};
</script>
<style scoped>
.table td,
.btn-sm {
  font-size: 1rem !important;
}
.table thead th {
  font-size: 0.9rem !important;
}

.h3,
h3 {
  font-size: 1.2rem !important;
}
</style>
